import { generateTypes, getCollectionActionHandlers } from 'helpers/actions'

const modelName = 'recurring_order'

export function get () {
  return {
    types: generateTypes(`${modelName}s`),
    api: api => api(`${modelName}s`)
  }
}

export const actions = {
  get
}

// Action Handlers
const initialState = []
const ACTION_HANDLERS = getCollectionActionHandlers({ modelName }) // TODO: Set a getTempId function here!

export default function (state = initialState, action) {
  let handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/RecurringOrders/modules/recurring_orders.js